import React from 'react';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/system';
import { PickersActionBar, PickersActionBarProps } from '@mui/x-date-pickers-pro';
import { SearchFormDatePickerFooter } from './SearchFormDatePickerFooter';

export const SearchFormDatePickerActionBar = (props: PickersActionBarProps) => (
    <Box
        sx={{
            gridColumn: '1/4',
            gridRow: '3',
        }}
    >
        <PickersActionBar {...props} />
        <Divider
            sx={{
                mb: 2,
            }}
        />
        <SearchFormDatePickerFooter sx={{ inlineSize: { xs: '300px', md: '100%' } }} />
    </Box>
);
